export default "__VITE_ASSET__BXGCtjni__"